export default class SystemConfigEntry {

    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.key = jsonResponse["key"];
        this.type = jsonResponse["type"];
        this.value = jsonResponse["value"];
        this.description = jsonResponse["description"];
    }
}
